// extracted by mini-css-extract-plugin
export default {"cls1":"Tooltip-cls1_DPu","cls2":"Tooltip-cls2__P3 Tooltip-cls1_DPu"};